// Cart constants
export const CART_REQUEST = 'CART_REQUEST'; 
export const CART_SUCCESS = 'CART_SUCCESS';
export const CART_FAIL = 'CART_FAIL';

export const CART_ADD_ITEM_REQUEST = 'CART_ADD_ITEM_REQUEST';
export const CART_ADD_ITEM_SUCCESS = 'CART_ADD_ITEM_SUCCESS';
export const CART_ADD_ITEM_FAIL = 'CART_ADD_ITEM_FAIL';

export const CART_UPDATE_ITEM_REQUEST = 'CART_UPDATE_ITEM_REQUEST';
export const CART_UPDATE_ITEM_SUCCESS = 'CART_UPDATE_ITEM_SUCCESS';
export const CART_UPDATE_ITEM_FAIL = 'CART_UPDATE_ITEM_FAIL';

export const CART_REMOVE_ITEM_REQUEST = 'CART_REMOVE_ITEM_REQUEST';
export const CART_REMOVE_ITEM_SUCCESS = 'CART_REMOVE_ITEM_SUCCESS';
export const CART_REMOVE_ITEM_FAIL = 'CART_REMOVE_ITEM_FAIL';

export const CART_CLEAR_REQUEST = 'CART_CLEAR_REQUEST';
export const CART_CLEAR_SUCCESS = 'CART_CLEAR_SUCCESS';
export const CART_CLEAR_FAIL = 'CART_CLEAR_FAIL';

export const CART_CLEAR_ITEMS = 'CART_CLEAR_ITEMS';